
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscribe/checkout",
      function () {
        return require("private-next-pages/subscribe/checkout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscribe/checkout"])
      });
    }
  